import { BlockId } from '@shared/block-ids';
import { ItemStack } from '../types';
import { MAX_STACK_SIZE, INVENTORY_SIZE, HOTBAR_SLOTS } from '../constants';

export class Inventory {
  slots: (ItemStack | null)[];
  selectedSlot = 0;

  constructor(creative = false) {
    this.slots = new Array(INVENTORY_SIZE).fill(null);

    if (creative) {
      this.fillCreative();
    }
    // Survival: start with empty inventory
  }

  private fillCreative(): void {
    this.slots[0] = { id: BlockId.GRASS, count: 64 };
    this.slots[1] = { id: BlockId.DIRT, count: 64 };
    this.slots[2] = { id: BlockId.STONE, count: 64 };
    this.slots[3] = { id: BlockId.WOOD_OAK, count: 64 };
    this.slots[4] = { id: BlockId.PLANKS_OAK, count: 64 };
    this.slots[5] = { id: BlockId.SAND, count: 64 };
    this.slots[6] = { id: BlockId.GLASS, count: 64 };
    this.slots[7] = { id: BlockId.BRICK, count: 64 };
    this.slots[8] = { id: BlockId.COBBLESTONE, count: 64 };
    this.slots[9] = { id: BlockId.LEAVES_OAK, count: 64 };
    this.slots[10] = { id: BlockId.COAL_ORE, count: 64 };
    this.slots[11] = { id: BlockId.IRON_ORE, count: 64 };
    this.slots[12] = { id: BlockId.GOLD_ORE, count: 64 };
    this.slots[13] = { id: BlockId.DIAMOND_ORE, count: 64 };
    this.slots[14] = { id: BlockId.BOOKSHELF, count: 64 };
    this.slots[15] = { id: BlockId.SNOW, count: 64 };
    this.slots[16] = { id: BlockId.SANDSTONE, count: 64 };
    this.slots[17] = { id: BlockId.TNT, count: 64 };
    this.slots[18] = { id: BlockId.CRAFTING_TABLE, count: 64 };
    this.slots[19] = { id: BlockId.FURNACE, count: 64 };
    this.slots[20] = { id: BlockId.TORCH, count: 64 };
    this.slots[21] = { id: BlockId.WATER, count: 64 };
    this.slots[22] = { id: BlockId.ICE, count: 64 };
    this.slots[23] = { id: BlockId.CLAY, count: 64 };
    this.slots[24] = { id: BlockId.CACTUS, count: 64 };
    this.slots[25] = { id: BlockId.GRAVEL, count: 64 };
    this.slots[26] = { id: BlockId.BEDROCK, count: 64 };
  }

  getSelectedItem(): ItemStack | null {
    return this.slots[this.selectedSlot];
  }

  selectSlot(slot: number): void {
    if (slot >= 0 && slot < HOTBAR_SLOTS) {
      this.selectedSlot = slot;
    }
  }

  scrollSlot(delta: number): void {
    this.selectedSlot = ((this.selectedSlot + delta) % HOTBAR_SLOTS + HOTBAR_SLOTS) % HOTBAR_SLOTS;
  }

  addItem(id: BlockId, count = 1): boolean {
    // Try to stack with existing
    for (let i = 0; i < this.slots.length; i++) {
      const slot = this.slots[i];
      if (slot && slot.id === id && slot.count < MAX_STACK_SIZE) {
        const canAdd = Math.min(count, MAX_STACK_SIZE - slot.count);
        slot.count += canAdd;
        count -= canAdd;
        if (count === 0) return true;
      }
    }

    // Find empty slot
    for (let i = 0; i < this.slots.length; i++) {
      if (!this.slots[i]) {
        const canAdd = Math.min(count, MAX_STACK_SIZE);
        this.slots[i] = { id, count: canAdd };
        count -= canAdd;
        if (count === 0) return true;
      }
    }

    return count === 0;
  }

  removeFromSelected(count = 1): void {
    const slot = this.slots[this.selectedSlot];
    if (!slot) return;
    slot.count -= count;
    if (slot.count <= 0) {
      this.slots[this.selectedSlot] = null;
    }
  }

  swapSlots(a: number, b: number): void {
    const temp = this.slots[a];
    this.slots[a] = this.slots[b];
    this.slots[b] = temp;
  }
}
